<app-navbar-style-two></app-navbar-style-two>

<div class="product" *ngFor="let img of product?.images" (click)="changeImage(img)">
  <div class="inner-banner">
    <div class="container">
      <div class="inner-title text-end">
        
        <ul class="mb-2">
          <li><a href="index.html">Home</a></li>
          <li><i class='bx bx-chevron-right'></i></li>
          <li>Products</li>
          <li><i class='bx bx-chevron-right'></i></li>
          <li>{{ product?.name }}</li>
        </ul>
        <h3>{{ product?.name }}</h3>
      </div>
    </div>
  </div>

  <div class="brand-img">
    <p>Brand : </p>
    <img [src]="getImg(product?.brand_img)" alt="" />
  </div>

  <div class="product-detail">
    <!-- LEFT IMAGE SECTION -->
    <div class="left">
    

      <img class="main-img" [src]="getImg(selectedImage)" alt="" />

      <div class="thumbs">
        <div class="thumb">
          <img [src]="getImg(img)" />
        </div>
      </div>
    </div>

    <!-- RIGHT DETAILS SECTION -->
    <div class="right">
      <div class="description">
        <h3>Description</h3>
        <p>{{ product?.description }}</p>

        <div class="highlights">
          <h4>Highlights</h4>
          <p><span class="strong">Brand :</span> {{ product?.brand?.name }}</p>
          <p><span class="strong">Size :</span> {{ product?.pack_size_name }} ml</p>
        </div>

        <div class="available">
          <h4>Available In</h4>
          <span class="size-chip">
            {{ product?.available_size }} <img src="assets/img/products/tick.svg" alt="tick" />
          </span>
        </div>
      </div>

      <!-- NUTRITION FACTS -->
      <div class="nutrition">

        <h3>Nutrition Facts</h3>

        <div class="nutrition-video text-center">
          <img [src]="getImg(product?.video_url)" alt="Nutrition Facts" />
        </div>

        <!-- <table>
          <tbody>
            <tr>
              <td>Total Fat {{ product?.nutritional?.total_fat }}g</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Saturated Fat {{ product?.nutritional?.saturated_fat }}g</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Trans Fat {{ product?.nutritional?.trans_fat }}g</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Cholesterol {{ product?.nutritional?.cholesterol }}mg</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Sodium {{ product?.nutritional?.sodium }}mg</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Total Carbohydrates {{ product?.nutritional?.total_carbohydrate }}g</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Dietary Fiber {{ product?.nutritional?.dietary_fiber }}g</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Total Sugars {{ product?.nutritional?.total_sugars }}g</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Added Sugars {{ product?.nutritional?.added_sugars }}g</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Protein {{ product?.nutritional?.protein }}g</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Calcium {{ product?.nutritional?.calcium }}mg</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Vitamin A {{ product?.nutritional?.vitamin_a }}mg</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Vitamin D3 {{ product?.nutritional?.vitamin_d3 }}mg</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Vitamin C {{ product?.nutritional?.vitamin_c }}mg</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Lactose {{ product?.nutritional?.lactose }}mg</td>
              <td>0%</td>
            </tr>

          </tbody>
        </table> -->
      </div>
    </div>
  </div>
</div>

<section class="download-section">
  <div class="left">
    <h3>Download Brochure</h3>
    <p>Get detailed insights about our products and services</p>
  </div>
  <button class="primary-btn">Download Now</button>
</section>

<app-footer-style-one></app-footer-style-one>